import { render } from "./MessagesInbox.vue?vue&type=template&id=b878e818&scoped=true"
import script from "./MessagesInbox.vue?vue&type=script&lang=js"
export * from "./MessagesInbox.vue?vue&type=script&lang=js"

import "./MessagesInbox.vue?vue&type=style&index=0&id=b878e818&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b878e818"]])

export default __exports__